import { render } from "./HomeQRCode.vue?vue&type=template&id=9128c198&ts=true"
import script from "./HomeQRCode.vue?vue&type=script&lang=ts"
export * from "./HomeQRCode.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__